// extracted by mini-css-extract-plugin
module.exports = {"breakpoint_xs":"30rem","breakpoint_sm":"48rem","breakpoint_md":"83.75rem","breakpoint_lg":"120rem","breakpoint_xl":"160rem"};